import { List } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  ActiveFloodIcon,
  InactiveFloodIcon,
  SilentActiveFloodIcon,
} from 'features/mapping/icons';
import { LegendListItem } from './LegendListItem';
import { LegendSectionTitle } from './LegendSectionTitle';

export const FloodsLegend = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <List
      disablePadding
      dense
      subheader={
        <LegendSectionTitle>{t('map.legends.floods.title')}</LegendSectionTitle>
      }
    >
      <LegendListItem
        iconSrc={ActiveFloodIcon.data}
        primaryText={t('map.legends.floods.legends.active.title')}
        secondary={t('map.legends.floods.legends.active.subtitle')}
        iconSize={24}
      />
      <LegendListItem
        iconSrc={InactiveFloodIcon.data}
        primaryText={t('map.legends.floods.legends.inactive.title')}
        secondary={t('map.legends.floods.legends.inactive.subtitle')}
        iconSize={24}
      />
      <LegendListItem
        iconSrc={SilentActiveFloodIcon.data}
        primaryText={t('map.legends.floods.legends.silent.title')}
        secondary={t('map.legends.floods.legends.silent.subtitle')}
        iconSize={24}
      />
    </List>
  );
};
